/* @ngInject */
export function SafetyPlanPresentationFactory() {
    return function SafetyPlanPresentation() {

        this.id = null;
        this.description = null;
    };
}
